import React from 'react';

export const SportBettingContext = React.createContext<string | null>(null);

export const useSportBettingContext = () => React.useContext(SportBettingContext);
